import React from 'react';
import { useParams } from 'react-router-dom';
import { useQueries } from '@tanstack/react-query';

import ContentPage from 'components/ContentView/ContentPage/ContentPage';
import useAlerts from 'utils/hooks/useAlerts';
import createQueryRequest from 'services/createQueryRequest';
import useAPI from 'services/useAPI';
import { ResourceType } from 'utils/types';
import { org2dashboards } from './queries';
import { DashboardsQueryKey } from 'components/Dashboard/useDashboardsQuery';
import RelationTable from 'components/RelationTable/RelationTable';
import useRelations from 'utils/hooks/useRelations';
import { useRelationData, createRelationQueryData, createOrgOwnerRelationQueryData } from './queries';


const OrgToDashboardRelations = ({ breadcrumbs }) => {
  const api = useAPI();
  const { orgId } = useParams();
  const [alerts,, addErrorAlert] = useAlerts();

  const [dashboardsQuery, dashboardRelationQuery, dashboardsOwnerQuery] = useQueries({
    queries: [
      { queryKey: DashboardsQueryKey.dashboards(), queryFn: createQueryRequest(api.core.getDashboards) },
      { queryKey: org2dashboards.org(createRelationQueryData(ResourceType.Dashboard, orgId)), queryFn: createQueryRequest(api.core.findRelationships) },
      { queryKey: org2dashboards.org(createOrgOwnerRelationQueryData(ResourceType.Dashboard)), queryFn: createQueryRequest(api.core.findRelationships) }
    ]
  });

  const dashboards = useRelationData({
    isLoading: dashboardsQuery.isLoading || dashboardRelationQuery.isLoading || dashboardsOwnerQuery.isLoading,
    resources: dashboardsQuery.data,
    resourceRelations: dashboardRelationQuery.data,
    ownedRelations: dashboardsOwnerQuery.data,
    resourceType: ResourceType.Dashboard
  });

  const { updateRelations, deleteRelations } = useRelations({
    refetchFn: dashboardRelationQuery.refetch,
    queryKey: org2dashboards.org(createRelationQueryData(ResourceType.Dashboard)),
    onError: addErrorAlert
  });

  return (
    <ContentPage
      breadcrumb={breadcrumbs}
    >
      { alerts }
      <RelationTable
        orgId={orgId}
        resources={dashboards}
        isLoading={dashboardsQuery.isLoading || dashboardRelationQuery.isLoading || dashboardsOwnerQuery.isLoading}
        updateRelationsFn={updateRelations.mutate}
        deleteRelationsFn={deleteRelations.mutate}
      />
    </ContentPage>
  );
};

export default OrgToDashboardRelations;
